// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.framerate-indicator_framerate-container_hYkUk {
  display: flex;
  align-items: center;
  padding: 0.25rem;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.framerate-indicator_framerate-label__twTJ {
  font-size: 0.625rem;
  font-weight: bold;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: var(--control-primary);
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-framerate-indicator/framerate-indicator.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,2DAA2D;EAC3D,6BAA6B;EAC7B,mBAAmB;AACrB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.framerate-container {\n  display: flex;\n  align-items: center;\n  padding: 0.25rem;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.framerate-label {\n  font-size: 0.625rem;\n  font-weight: bold;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  color: var(--control-primary);\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"framerate-container": `framerate-indicator_framerate-container_hYkUk`,
	"framerateContainer": `framerate-indicator_framerate-container_hYkUk`,
	"framerate-label": `framerate-indicator_framerate-label__twTJ`,
	"framerateLabel": `framerate-indicator_framerate-label__twTJ`
};
export default ___CSS_LOADER_EXPORT___;
